import { createSlice } from "@reduxjs/toolkit";

type props = {
  isFetching: boolean,
  medecinTypes: any[],
  error: string[]
}

const initialState: props = {
  isFetching: false,
  medecinTypes: [],
  error: []
}

const medecinTypeSlice = createSlice({
  name: "medecinTypes",
  initialState,
  reducers: {
    statusMedecinTypeStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusMedecinTypeSuccess: (state, action) => {
      state.isFetching = false
      state.medecinTypes = action.payload
      state.error = []
    },
    statusMedecinTypeFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusMedecinTypeStart,
  statusMedecinTypeSuccess,
  statusMedecinTypeFailure 
} = medecinTypeSlice.actions

export default medecinTypeSlice.reducer